import useSWR from 'swr';
import server from '../global/server';
import {useApp} from '../context/AppContext';
import useHandleErrors from './useHandleErrors';

export function useFetch(url, params, blocked = false) {
    const {setLoading} = useApp();
    const {data, error, mutate} = useSWR(
        {url, params},
        async ({url, params}) => {
            setLoading(true);
            const {data} = await server.get(url, params);

            return data;
        },
        {
            errorRetryCount: 1,
        },
    );

    setLoading(false);
    useHandleErrors(error)

    return {data: data?.data, error, isLoading: !error && !data, mutate};
}
